import { webAccountText } from '@storytune/assets/lang/webAccount'

/** 原始异常留在诊断中，普通界面只显示可操作的中文提示。 */
export function reportNetworkError(error: unknown): string {
  console.error('网络请求失败', error)
  return webAccountText.networkError
}

/** 兼顾浏览器直接抛出的异常和已保存在状态中的网络错误，不改写业务错误。 */
export function localizeNetworkError(message: string): string {
  return /^(?:TypeError:\s*)?(?:Network error(?::|$)|Failed to fetch$|NetworkError\b|Network request failed\b|Load failed$|fetch failed$)/i.test(
    message.trim(),
  )
    ? webAccountText.networkError
    : message
}
